let baseURL = '';
let url = location.href;
if(url.indexOf('http://localhost') != -1 || url.indexOf('sit') != -1){//测试环境
    //baseURL='http://sever_test.yongxintao.com'
    baseURL='https://server-order-api.yongxintao.com/'
    //baseURL = 'http://api.yxt.com/'
}else{//正式环境
    baseURL='https://server-order-api.yongxintao.com/'
    //baseURL='https://sever-test.yongxintao.com/'
    //baseURL = 'http://api.yxt.com/'
}
export default baseURL;
